"use client";
import {
  Attachments,
  Bubble,
  Conversations,
  Prompts,
  Sender,
  Welcome,
  // useXAgent,
  useXChat,
} from "@ant-design/x";
import { createStyles } from "antd-style";
import React, { useEffect } from "react";
import { useTranslation } from "../app/lib/i18n/index";
import markdownit from "markdown-it";
import type { BubbleProps } from "@ant-design/x";
import MessageSenderMobile from "./message-sender-mobile";
import { Search, X, FilePenLine, Menu } from "lucide-react";
import { Select } from "antd";
import { useRouter } from "next/navigation";
import Link from "next/link";
import { usePathname, useSearchParams } from "next/navigation";
import GoogleLogin from "./google-login"
import {
  CloudUploadOutlined,
  CommentOutlined,
  EllipsisOutlined,
  FireOutlined,
  HeartOutlined,
  PaperClipOutlined,
  PlusOutlined,
  ReadOutlined,
  ShareAltOutlined,
  SmileOutlined,
} from "@ant-design/icons";
import { Badge, Button, type GetProp, Space, Drawer } from "antd";
import Script from "next/script";
import hljs from "highlight.js"; // 引入 highlight.js
import "highlight.js/styles/atom-one-dark.css";
import markdownItKatex from "markdown-it-katex";
import "katex/dist/katex.min.css"; // 引入 KaTeX 样式
import mk from "@traptitech/markdown-it-katex";
import API from "@/lib/api";
import { AppContextProvider } from "@/contexts/AppContext";
import PricingPlans from "./pricing-plans";
import { loadStripe } from "@stripe/stripe-js";
import type { DrawerProps } from "antd";
import {
  DEEP_MODE_MODEL_ID,
  MODEL_SELECT_OPTIONS,
  getRandomModel as pickRandomModel,
  isPaidModel,
} from "./model-config";

const enData = {
  en: "English",
  zh: "Chinese",
  es: "Spanish",
  ar: "Arabic",
  ru: "Russian",
  fr: "French",
  de: "German",
  pt: "Portuguese",
  ja: "Japanese",
  ko: "Korean",
  it: "Italian",
  nl: "Dutch",
  tr: "Turkish",
  "hi-IN": "Hindi",
  el: "Greek",
  sv: "Swedish",
  da: "Danish",
  fi: "Finnish",
  no: "Norwegian",
  pl: "Polish",
  hu: "Hungarian",
  cs: "Czech",
  sk: "Slovak",
  ro: "Romanian",
  bg: "Bulgarian",
  "zh-Hant": "Traditional Chinese",
  ms: "Malay",
  bn: "Bengali",
  id: "Indonesian",
  "ur-PK": "Urdu",
  "sw-KE": "Swahili",
  "pa-IN": "Punjabi",
  vi: "Vietnamese",
  "mr-IN": "Marathi",
  "te-IN": "Telugu",
  "ta-IN": "Tamil",
  th: "Thai",
  "gu-IN": "Gujarati",
  "kn-IN": "Kannada",
  uk: "Ukrainian",
  "ml-IN": "Malayalam",
  my: "Burmese",
  "tl-PH": "Tagalog",
  am: "Amharic",
  so: "Somali",
  kk: "Kazakh",
  hy: "Armenian",
  ca: "Catalan",
  sr: "Serbian",
  sq: "Albanian",
  hr: "Croatian",
  mn: "Mongolian",
  ka: "Georgian",
  bs: "Bosnian",
  lt: "Lithuanian",
  mk: "Macedonian",
  si: "Slovenian",
  lv: "Latvian",
  et: "Estonian",
  is: "Icelandic",
  "czat-ai": "Polish",
  "chat-gpt-pl": "Polish",
  "sztuczna-inteligencja-chat": "Polish",
  // "ki-chat-gratis": "German",
  "ki-text-generator-kostenlos-ohne-anmeldung": "German",
  "ki-fragen-stellen": "German",
  "inteligencia-artificial-gratis": "Spanish",
  "yapay-zeka-soru-sor": "Turkish",
  "chatgpt-yapay-zeka": "Turkish",
  "intelligence-artificielle-gratuite": "French",
  "site-gpt-gratuito": "Portuguese",
  "inteligencia-artificial-gratuito": "Portuguese",
  "chat-gpt-ita": "Italian",
  "ia-gratis": "Italian",
  talkai: "English",
  "product-name-generator": "English",
  "paragraph-rewriter": "English",
  "summary-generator": "English",
  "love-letter-generator": "English",
  "ai-video-description-generator": "English",
  "flower-shop-business-name-generator": "English",
  "fantasy-name-generator": "English",
  "french-name-generator": "English",
  "skin-care-business-name-generator": "English",
  "tea-business-name-generator": "English",
  "music-business-name-generator": "English",
  "street-name-generator": "English",
  "business-name-generator": "English",
  "book-title-generator": "English",
  "middle-name-generator": "English",
  "lip-gloss-business-name-generator": "English",
  "ai-lyrics-generator": "English",
  "random-pokemon-generator": "English",
  "crochet-business-name-generator": "English",
  "tech-business-name-generator": "English",
  "cosmetic-business-name-generator": "English",
  "fantasy-character-name-generator": "English",
  "german-name-generator": "English",
  "plot-generator": "English",
  "youtube-channel-description-generator": "English",
  "ai-business-plan-generator": "English",
  "digital-marketing-business-name-generator": "English",
  "event-business-name-generator": "English",
  "ai-script-generator": "English",
  "youtube-title-generator": "English",
  "username-generator": "English",
  "agency-business-name-generator": "English",
  "glitch-text-generator": "English",
  "hook-generator": "English",
  "ai-homework-helper": "English",
  "ai-review-generator": "English",
  "baby-name-generator": "English",
  "cat-name-generator": "English",
  "italian-name-generator": "English",
  "alt-text-generator": "English",
  "last-name-generator": "English",
  "character-personality-generator": "English",
  "food-truck-business-name-generator": "English",
  "funny-business-name-generator": "English",
  "team-name-generator": "English",
  "instagram-bio-generator": "English",
  "pictionary-word-generator": "English",
  "instagram-caption-generator": "English",
  "cake-business-name-generator": "English",
  "tiefling-name-generator": "English",
  "sentence-rewriter": "English",
  "rewording-tool": "English",
  "paragraph-generator": "English",
  "fashion-store-business-name-generator": "English",
  "cover-letter-generator": "English",
  "god-name-generator": "English",
  "nickname-generator.1": "English",
  "nickname-generator": "English",
  "sportswear-business-name-generator": "English",
  "random-name-generator": "English",
  "rapper-name-generator": "English",
  "random-letter-generator": "English",
  "dessert-business-name-generator": "English",
  "aesthetic-business-name-generator": "English",
  "random-movie-generator": "English",
  "pen-name-generator": "English",
  "fitness-business-name-generator": "English",
  "ai-answer-generator": "English",
  "song-title-generator": "English",
  "facebook-hashtag-generator": "English",
  "japanese-name-generator": "English",
  "photography-business-name-generator": "English",
  "character-headcanon-generator": "English",
  "interior-design-business-name-generator": "English",
  "fake-name-generator": "English",
  "essay-generator": "English",
  "ai-rhyme-generator": "English",
  "slime-business-name-generator": "English",
  "dialogue-generator": "English",
  "star-wars-name-generator": "English",
  "linkedin-headline-generator": "English",
  "poem-generator": "English",
  "googel-ads-ad-copy-generator": "English",
  "candle-business-name-generator": "English",
  "craft-store-business-name-generator": "English",
  "seo-title-generator": "English",
  "backstory-generator": "English",
  "paragraph-expander": "English",
  "elf-name-generator": "English",
  "character-name-generator": "English",
  "arabic-name-generator": "English",
  "soap-business-name-generator": "English",
  "thesis-statement-generator": "English",
  "russian-name-generator": "English",
  "band-name-generator": "English",
  "ai-slogan-generator": "English",
  "ai-story-generator": "English",
  "random-animal-generator": "English",
  "instagram-hashtag-generator": "English",
  "t-shirt-business-name-generator": "English",
  "viking-name-generator": "English",
  "anagram-generator": "English",
  "sentence-shortener": "English",
  "story-title-generator": "English",
  "app-business-name-generator": "English",
  "health-business-name-generator": "English",
  "country-name-generator": "English",
  "instagram-name-generator": "English",
  "pirate-name-generator": "English",
  "ai-paper-generator": "English",
  "dragon-name-generator": "English",
  "dnd-name-generator": "English",
  "superhero-name-generator": "English",
  "print-shop-business-name-generator": "English",
  "acronym-generator": "English",
  "it-business-name-generator": "English",
  "korean-name-generator": "English",
  "ai-job-description-generator": "English",
  "shoes-business-name-generator": "English",
  "sentence-expander": "English",
  "email-generator": "English",
  "electronics-business-name-generator": "English",
  "ai-email-generator": "English",
  "thesis-generator": "English",
  "greek-god-name-generator": "English",
  "essay-title-generator": "English",
  "babysitting-business-name-generator": "English",
  "boutique-business-name-generator": "English",
  "city-name-generator": "English",
  "emoji-translator": "English",
  "ai-rewriter": "English",
  "travel-business-name-generator": "English",
  "food-business-name-generator": "English",
  "furniture-store-business-name-generator": "English",
  "motto-generator": "English",
  "ice-cream-business-name-generator": "English",
  "lorem-ipsum-generator": "English",
  "beauty-business-name-generator": "English",
  "skyrim-script-extender": "English",
  "jewelry-store-business-name-generator": "English",
  "paragraph-shortener": "English",
  "game-business-name-generator": "English",
  "clothing-store-business-name-generator": "English",
  "candy-business-name-generator": "English",
  "villain-name-generator": "English",
  "book-title-generator.1": "English",
  "ai-letter-generator": "English",
  "cafe-business-name-generator": "English",
  "perfume-business-name-generator": "English",
  "essay-title-generator.1": "English",
  "cookie-business-name-generator": "English",
  "conclusion-generator": "English",
  "graphic-design-business-name-generator": "English",
  "real-estate-business-name-generator": "English",
  "outline-generator": "English",
  "meta-description-generator": "English",
  "ship-name-gnerator": "English",
  "hair-business-name-generator": "English",
  "tagalog-translate-bisaya": "English",
  "ilocano-translate-tagalog": "English",
  "tagalog-to-indonesia": "English",
  "english-translate-serbian": "English",
  "english-to-icelandic": "English",
  "english-translate-armenian": "English",
  "danish-translate-english": "English",
  "japanese-translate-tagalog": "English",
  "english-translate-czech": "English",
  "somali-translate-english": "English",
  "english-to-ukrainian": "English",
  "serbian-translate-english": "English",
  "english-translate-finnish": "English",
  "cebuano-translate-tagalog": "English",
  "english-translate-latvian": "English",
  "ukrainian-to-english": "English",
  "tagalog-translate-cebuano": "English",
  "english-translate-somali": "English",
  "hungarian-to-english": "English",
  "english-translate-cebuano": "English",
  "bisaya-translate-tagalog": "English",
  "english-translate-swedish": "English",
  "english-to-bulgarian": "English",
  "waray-translate-tagalog": "English",
  "tagalog-translate-english": "English",
  "english-translate-swahili": "English",
  "indonesia-to-tagalog": "English",
  "tagalog-translate-ilocano": "English",
  "norwegian-to-english": "English",
  "english-to-hungarian": "English",
  "english-translate-khmer": "English",
  "tagalog-translate-spanish": "English",
  "bosnian-translate-english": "English",
  "english-translate-bosnian": "English",
  "czech-translate-english": "English",
  "english-to-thai": "English",
  "tagalog-translate-chinese": "English",
  "bisaya-translate-english": "English",
  "croatian-translate-english": "English",
  "finnish-translate-english": "English",
  "ilonggo-translate-tagalog": "English",
  "persian-translate-english": "English",
  "arabic-translate-tagalog": "English",
  "claude-4": "English",
  "deepclaude": "English",
  "deepseek-r1": "English",
  "gpt-5": "English",
  "grok-3": "English",
};

const lgData = {
  en: "English",
  zh: "中文 (简体)",
  es: "Español",
  ar: "العربية",
  ru: "Русский",
  fr: "Français",
  de: "Deutsch",
  pt: "Português",
  ja: "日本語",
  ko: "한국어",
  it: "Italiano",
  nl: "Nederlands",
  tr: "Türkçe",
  "hi-IN": "हिंदी",
  el: "Ελληνικά",
  sv: "Svenska",
  da: "Dansk",
  fi: "Suomi",
  no: "Norsk",
  pl: "Polski",
  hu: "Magyar",
  cs: "Čeština",
  sk: "Slovenčina",
  ro: "Română",
  bg: "Български",
  "zh-Hant": "中文 (繁體)",
  ms: "Bahasa Melayu",
  bn: "বাংলা",
  id: "Bahasa Indonesia",
  "ur-PK": "اردو",
  "sw-KE": "Kiswahili",
  "pa-IN": "ਪੰਜਾਬੀ",
  vi: "Tiếng Việt",
  "mr-IN": "मराठी",
  "te-IN": "తెలుగు",
  "ta-IN": "தமிழ்",
  th: "ไทย",
  "gu-IN": "ગુજરાતી",
  "kn-IN": "ಕನ್ನಡ",
  uk: "Українська",
  "ml-IN": "മലയാളം",
  my: "မြန်မာဘာသာ",
  "tl-PH": "Tagalog",
  am: "አማርኛ",
  so: "Soomaali",
  kk: "Қазақ",
  hy: "Հայերեն",
  ca: "Català",
  sr: "Српски",
  sq: "Shqip",
  hr: "Hrvatski",
  mn: "Монгол",
  ka: "ქართული",
  bs: "Bosanski",
  lt: "Lietuvių",
  mk: "Македонски",
  si: "සිංහල",
  lv: "Latviešu",
  et: "Eesti",
  is: "Íslenska",
};

const md = new markdownit({
  html: true, // 允许 HTML 标签
  // breaks: true,      // 转换段落里的 '\n' 到 <br>
  linkify: true, // 自动转换 URL 到链接
  typographer: true, // 启用一些语言中性的替换 + 引号美化
  highlight: (str, lang) => {
    if (lang && hljs.getLanguage(lang)) {
      try {
        return `<pre class="hljs"><code>${
          hljs.highlight(str, { language: lang }).value
        }</code></pre>`;
      } catch (__) {}
    }
    return `<pre class="hljs"><code>${md.utils.escapeHtml(str)}</code></pre>`;
  },
});

md.use(mk, {
  throwOnError: false,
  errorColor: "#cc0000",
});

async function chatAPIRequest({
  network,
  url,
  model,
  question,
  language = "English",
  sessionId = null,
  previousQuestion = null,
  previousAnswer = null,
  onStream = null, // 流式回调函数
}) {
  const headers = {
    "Content-Type": "application/json",
    Authorization:
      typeof window !== "undefined" && localStorage.getItem("token")
        ? `Bearer ${localStorage.getItem("token")}`
        : "",
  };
  const body = JSON.stringify({
    model,
    question,
    language,
    sessionId,
    previousQuestion,
    previousAnswer,
  });

  try {
    const response = await fetch(url, {
      method: "POST",
      headers,
      body,
    });

    if (!response.ok) {
      // throw new Error(`HTTP error! Status: ${response.status}`);
      throw {
        status: response.status,
        statusText: response.statusText,
      };
    }

    // 检查是否为流式响应
    const contentType = response.headers.get("Content-Type");
    if (contentType && contentType.includes("text/event-stream")) {
      const reader = response.body.getReader();
      const decoder = new TextDecoder("utf-8");
      let done = false;

      while (!done) {
        const { value, done: readerDone } = await reader.read();
        done = readerDone;
        if (value) {
          const chunk = decoder.decode(value, { stream: true });
          if (onStream) onStream(chunk); // 调用流式回调函数
        }
      }
    } else {
      // 非流式响应
      const result = await response.json();
      return result;
    }
  } catch (error) {
    console.error("API Request Failed:", error);
    // if (error.status == 429) {
    //   // 未登录，跳转到登录页
    //   useRouter().push("/login");
    //   // throw new Error("Not logged in");
    // } else {
      throw error;
    // }
  }
}

const renderTitle = (icon: React.ReactElement, title: string) => (
  <Space align="start">
    {icon}
    <span>{title}</span>
  </Space>
);

const useStyle = createStyles(({ token, css }) => {
  return {
    layout: css`
      width: 100%;
      min-width: 1000px;
      height: 722px;
      border-radius: ${token.borderRadius}px;
      display: flex;
      background: ${token.colorBgContainer};
      font-family: AlibabaPuHuiTi, ${token.fontFamily}, sans-serif;

      .ant-prompts {
        color: ${token.colorText};
      }
    `,
    menu: css`
      background: ${token.colorBgLayout}80;
      width: 260px;
      // height: 100%;
      display: flex;
      flex-direction: column;
    `,
    conversations: css`
      padding: 0 12px;
      flex: 1;
      overflow-y: auto;
    `,
    chat: css`
      // height: 100%;
      // width: 100%;
      // max-width: 100%;
      // // max-width: 800px;
      // // margin: 0 auto;
      // box-sizing: border-box;
      // display: flex;
      // flex-direction: column;
      // // padding: ${token.paddingLG}px;
      // // padding: 24px 0;
      // gap: 16px;
    `,
    messages: css`
      flex: 1;
      padding: 0 300px;
    `,
    placeholder: css`
      padding-top: 32px;
    `,
    sender: css`
      box-shadow: none;
    `,
    logo: css`
      display: flex;
      height: 72px;
      align-items: center;
      // justify-content: start;
      padding: 0 24px;
      box-sizing: border-box;

      img {
        width: 24px;
        height: 24px;
        display: inline-block;
      }

      span {
        display: inline-block;
        margin: 0 8px;
        font-weight: bold;
        color: ${token.colorText};
        font-size: 16px;
        width: 66px;
        height: 30px;
        font-family: DM Sans, DM Sans;
        font-weight: bold;
        font-size: 18px;
        color: #1d1d1d;
        line-height: 30px;
        text-align: left;
        font-style: normal;
        text-transform: none;
      }
    `,
    addBtn: css`
      background: #1677ff0f;
      border: 1px solid #1677ff34;
      width: calc(100% - 24px);
      margin: 0 12px 24px 12px;
    `,
  };
});

const IndependentMobile = ({ language, locale }) => {
  // const { t, i18n } = useTranslation(language, "translation");
  // console.log("Current language:", i18n.language);

  // console.log(locale["freeChatgpt"]); // 根据 key 获取翻译文本
  const router = useRouter();

  const isValidLanguage = (language) => {
    const invalidLanguages = [
      "product-name-generator",
      "paragraph-rewriter",
      "summary-generator",
      "love-letter-generator",
      "ai-video-description-generator",
      "flower-shop-business-name-generator",
      "fantasy-name-generator",
      "french-name-generator",
      "skin-care-business-name-generator",
      "tea-business-name-generator",
      "music-business-name-generator",
      "street-name-generator",
      "business-name-generator",
      "book-title-generator",
      "middle-name-generator",
      "lip-gloss-business-name-generator",
      "ai-lyrics-generator",
      "random-pokemon-generator",
      "crochet-business-name-generator",
      "tech-business-name-generator",
      "cosmetic-business-name-generator",
      "fantasy-character-name-generator",
      "german-name-generator",
      "plot-generator",
      "youtube-channel-description-generator",
      "ai-business-plan-generator",
      "digital-marketing-business-name-generator",
      "event-business-name-generator",
      "ai-script-generator",
      "youtube-title-generator",
      "username-generator",
      "agency-business-name-generator",
      "glitch-text-generator",
      "hook-generator",
      "ai-homework-helper",
      "ai-review-generator",
      "baby-name-generator",
      "cat-name-generator",
      "italian-name-generator",
      "alt-text-generator",
      "last-name-generator",
      "character-personality-generator",
      "food-truck-business-name-generator",
      "funny-business-name-generator",
      "team-name-generator",
      "instagram-bio-generator",
      "pictionary-word-generator",
      "instagram-caption-generator",
      "cake-business-name-generator",
      "tiefling-name-generator",
      "sentence-rewriter",
      "rewording-tool",
      "paragraph-generator",
      "fashion-store-business-name-generator",
      "cover-letter-generator",
      "god-name-generator",
      "nickname-generator.1",
      "nickname-generator",
      "sportswear-business-name-generator",
      "random-name-generator",
      "rapper-name-generator",
      "random-letter-generator",
      "dessert-business-name-generator",
      "aesthetic-business-name-generator",
      "random-movie-generator",
      "pen-name-generator",
      "fitness-business-name-generator",
      "ai-answer-generator",
      "song-title-generator",
      "facebook-hashtag-generator",
      "japanese-name-generator",
      "photography-business-name-generator",
      "character-headcanon-generator",
      "interior-design-business-name-generator",
      "fake-name-generator",
      "essay-generator",
      "ai-rhyme-generator",
      "slime-business-name-generator",
      "dialogue-generator",
      "star-wars-name-generator",
      "linkedin-headline-generator",
      "poem-generator",
      "googel-ads-ad-copy-generator",
      "candle-business-name-generator",
      "craft-store-business-name-generator",
      "seo-title-generator",
      "backstory-generator",
      "paragraph-expander",
      "elf-name-generator",
      "character-name-generator",
      "arabic-name-generator",
      "soap-business-name-generator",
      "thesis-statement-generator",
      "russian-name-generator",
      "band-name-generator",
      "ai-slogan-generator",
      "ai-story-generator",
      "random-animal-generator",
      "instagram-hashtag-generator",
      "t-shirt-business-name-generator",
      "viking-name-generator",
      "anagram-generator",
      "sentence-shortener",
      "story-title-generator",
      "app-business-name-generator",
      "health-business-name-generator",
      "country-name-generator",
      "instagram-name-generator",
      "pirate-name-generator",
      "ai-paper-generator",
      "dragon-name-generator",
      "dnd-name-generator",
      "superhero-name-generator",
      "print-shop-business-name-generator",
      "acronym-generator",
      "it-business-name-generator",
      "korean-name-generator",
      "ai-job-description-generator",
      "shoes-business-name-generator",
      "sentence-expander",
      "email-generator",
      "electronics-business-name-generator",
      "ai-email-generator",
      "thesis-generator",
      "greek-god-name-generator",
      "essay-title-generator",
      "babysitting-business-name-generator",
      "boutique-business-name-generator",
      "city-name-generator",
      "emoji-translator",
      "ai-rewriter",
      "travel-business-name-generator",
      "food-business-name-generator",
      "furniture-store-business-name-generator",
      "motto-generator",
      "ice-cream-business-name-generator",
      "beauty-business-name-generator",
      "skyrim-script-extender",
      "jewelry-store-business-name-generator",
      "paragraph-shortener",
      "game-business-name-generator",
      "clothing-store-business-name-generator",
      "candy-business-name-generator",
      "villain-name-generator",
      "book-title-generator.1",
      "ai-letter-generator",
      "cafe-business-name-generator",
      "perfume-business-name-generator",
      "essay-title-generator.1",
      "cookie-business-name-generator",
      "conclusion-generator",
      "graphic-design-business-name-generator",
      "real-estate-business-name-generator",
      "outline-generator",
      "meta-description-generator",
      "ship-name-gnerator",
      "hair-business-name-generator",
      "tagalog-translate-bisaya",
      "ilocano-translate-tagalog",
      "tagalog-to-indonesia",
      "english-translate-serbian",
      "english-to-icelandic",
      "english-translate-armenian",
      "danish-translate-english",
      "japanese-translate-tagalog",
      "english-translate-czech",
      "somali-translate-english",
      "english-to-ukrainian",
      "serbian-translate-english",
      "english-translate-finnish",
      "cebuano-translate-tagalog",
      "english-translate-latvian",
      "ukrainian-to-english",
      "tagalog-translate-cebuano",
      "english-translate-somali",
      "hungarian-to-english",
      "english-translate-cebuano",
      "bisaya-translate-tagalog",
      "english-translate-swedish",
      "english-to-bulgarian",
      "waray-translate-tagalog",
      "tagalog-translate-english",
      "english-translate-swahili",
      "indonesia-to-tagalog",
      "tagalog-translate-ilocano",
      "norwegian-to-english",
      "english-to-hungarian",
      "english-translate-khmer",
      "tagalog-translate-spanish",
      "bosnian-translate-english",
      "english-translate-bosnian",
      "czech-translate-english",
      "english-to-thai",
      "tagalog-translate-chinese",
      "bisaya-translate-english",
      "croatian-translate-english",
      "finnish-translate-english",
      "ilonggo-translate-tagalog",
      "persian-translate-english",
      "arabic-translate-tagalog",
      "claude-4",
      "deepclaude",
      "deepseek-r1",
      "gpt-5",
      "grok-3"
    ];

    // 如果语言存在于无效列表中，则返回 false
    console.log("language", language, !invalidLanguages.includes(language));
    return !invalidLanguages.includes(language);
  };

  const [isCustomMade, setIsCustomMade] = React.useState(
    isValidLanguage(language)
  );

  const defaultConversationsItems = [
    {
      key: "0",
      label: locale["newConversation"],
    },
  ];
  // ==================== Style ====================
  const { styles } = useStyle();

  // ==================== State ====================
  const [headerOpen, setHeaderOpen] = React.useState(false);

  const [content, setContent] = React.useState("");

  const [conversationsItems, setConversationsItems] = React.useState(
    defaultConversationsItems
  );

  const [activeKey, setActiveKey] = React.useState(
    defaultConversationsItems[0].key
  );

  const [attachedFiles, setAttachedFiles] = React.useState<
    GetProp<typeof Attachments, "items">
  >([]);

  const [isLoading, setIsLoading] = React.useState(false);

  const [messages, setMessages] = React.useState([]);

  // const { messages, setMessages } = useXChat({});

  // 定义语言与 URL 的映射
  const languageUrls = {
    en: "/en",
    zh: "/zh",
    es: "/es",
    ar: "/ar",
    ru: "/ru",
    fr: "/fr",
    de: "/de",
    pt: "/pt",
    ja: "/ja",
    ko: "/ko",
    it: "/it",
    nl: "/nl",
    tr: "/tr",
    hi: "/hi-IN",
    el: "/el",
    sv: "/sv",
    da: "/da",
    fi: "/fi",
    no: "/no",
    pl: "/pl",
    hu: "/hu",
    cs: "/cs",
    sk: "/sk",
    ro: "/ro",
    bg: "/bg",
    "zh-Hant": "/zh-Hant",
    ms: "/ms",
    bn: "/bn",
    id: "/id",
    ur: "/ur-PK",
    sw: "/sw-KE",
    pa: "/pa-IN",
    vi: "/vi",
    mr: "/mr-IN",
    te: "/te-IN",
    ta: "/ta-IN",
    th: "/th",
    gu: "/gu-IN",
    kn: "/kn-IN",
    uk: "/uk",
    ml: "/ml-IN",
    my: "/my",
    tl: "/tl-PH",
    am: "/am",
    so: "/so",
    kk: "/kk",
    hy: "/hy",
    ca: "/ca",
    sr: "/sr",
    sq: "/sq",
    hr: "/hr",
    mn: "/mn",
    ka: "/ka",
    bs: "/bs",
    lt: "/lt",
    mk: "/mk",
    si: "/si",
    lv: "/lv",
    et: "/et",
    is: "/is",
  };
  // useEffect(() => {
  //   // 获取当前 URL 的查询参数
  //   if (["czat-ai", "chat-gpt-pl", "sztuczna-inteligencja-chat", "ki-text-generator-kostenlos-ohne-anmeldung", "ki-fragen-stellen", "inteligencia-artificial-gratis" , "yapay-zeka-soru-sor", "chatgpt-yapay-zeka", "intelligence-artificielle-gratuite", "site-gpt-gratuito","inteligencia-artificial-gratuito", "chat-gpt-ita", "ia-gratis", "talkai"].includes(language)) return;
  //   const searchParams = new URLSearchParams(window.location.search);
  //   console.log(
  //     "Detected 'manual' query parameter:",
  //     searchParams.get("manual")
  //   );
  //   setTimeout(() => {
  //     // 删除 'manual' 参数
  //     searchParams.delete("manual");

  //     // 更新浏览器 URL（不刷新页面）
  //     const newUrl = `${window.location.pathname}?${searchParams.toString()}`;
  //     window.history.replaceState(null, "", newUrl);
  //   }, 500);
  //   if (searchParams.get("manual")) return; // 用户手动切换时不执行自动跳转
  //   // 获取浏览器语言
  //   const browserLanguage = navigator.language || navigator.userLanguage;
  //   const primaryLanguage = browserLanguage.split("-")[0]; // 提取基础语言代码

  //   // 匹配语言的路由路径
  //   const targetRoute =
  //     languageUrls[browserLanguage] || // 精确匹配（带区域代码）
  //     languageUrls[primaryLanguage] || // 基础语言匹配
  //     languageUrls.en; // 默认跳转到英文页面

  //   // 跳转到目标路由
  //   if (router.pathname !== targetRoute) {
  //     router.replace(targetRoute); // 使用 replace 避免在历史记录中保留跳转前的路径
  //   }
  // }, [router]);

  useEffect(() => {
    // 定义全局处理函数
    (window as any).handleQuestionClick = (text: string) => {
      console.log("Clicked text:", text);
      // setNetwork(false);
      // 这里可以处理点击事件，比如：
      // setTimeout(()=> {
      onSubmit(text, activeKey); // 直接将点击的文本作为新的问题发送
      // }, 500);
    };

    // 清理函数
    return () => {
      delete (window as any).handleQuestionClick;
    };
  }, [activeKey]);

  useEffect(() => {
    if (activeKey !== undefined) {
      setMessages([]);
    }
  }, [activeKey]);
  const containerRef = React.useRef(null);

  useEffect(() => {
    if (containerRef.current) {
      containerRef.current.scrollTop = containerRef.current.scrollHeight;
    }
  }, [messages]); // 当消息更新时触发滚动

  let chunkBuffer = "";

  const handleNewMessages = (newMessages) => {
    // if (typeof newMessages === "string") {
    //   // 全局替换所有的 \n 为 <br/>
    //   newMessages = newMessages.replace(/\\n/g, "<br/>");
    //   console.log("已替换所有换行符为 <br/>");
    // } else {
    //   console.log("输入不是字符串，无需处理");
    // }
    return newMessages;
  };
  // ==================== Event ====================
  const onSubmit = (nextContent: string, id) => {
    if (isPaidModel(currentModel) && !isProUser) {
      setOpen(true);
      return;
    }
    if (!nextContent) return;
    // onRequest(nextContent); // 备注这个是干啥的
    setMessages((prev) => [
      ...prev,
      {
        id: `${prev.length}`,
        message: nextContent,
        status: "local",
        role: "local",
      },
    ]);
    let assistantMessage = "";
    let shouldConcatenate = true;
    let shouldRenderSource = false;
    let questionData = "";
    let sourceData = "";
    let streamHasError = false;
    const showAssistantError = (error?: any) => {
      const status = error?.status;
      const errorMessage =
        status === 401 || status === 430
          ? "This model requires an active subscription. Please choose a free model or upgrade."
          : "The selected model did not return a response. Please choose another model and try again.";

      setIsLoading(false);
      setMessages((prevMessages) => {
        const newMessages = [...prevMessages];
        const lastMessage = newMessages[newMessages.length - 1];
        if (lastMessage?.role === "ai") {
          lastMessage.message = errorMessage;
          lastMessage.status = "ai";
        } else {
          newMessages.push({
            message: errorMessage,
            status: "ai",
            role: "ai",
          });
        }
        return newMessages;
      });
    };
    setIsLoading(true);
    setMessages((prev) => [
      ...prev,
      {
        message: "",
        status: "ai",
        role: "ai",
      },
    ]);
    chatAPIRequest({
      // model: "gpt-4o-mini",
      network,
      url: network
        ? "https://api.heckai.weight-wave.com/api/ha/v1/search"
        : "https://api.heckai.weight-wave.com/api/ha/v1/chat",
      model: currentModel,
      question: (!isCustomMade ? locale["Prompt"] : "") + nextContent,
      language: enData[language],
      sessionId: id,
      previousQuestion: !isCustomMade
        ? null
        : messages
            .slice()
            .reverse()
            .find((msg) => msg.role === "local")?.message || null,
      previousAnswer: !isCustomMade
        ? null
        : messages
            .slice()
            .reverse()
            .find((msg) => msg.role === "ai")?.message || null,
      onStream: (chunk) => {
        console.log("Streamed chunk--------------:", chunk);
        setNetwork(false);
        const lines = chunk
          .split("\n")
          .map((line) => (line === "data: " ? "data: \n" : line));
        // const lines = chunk
        // .split(/\n{1}(?=data:|$)/) // 按照每个 "data:" 后面的末尾两个换行符分割
        // .map(item => item.trim()) // 去掉每个部分的首尾多余空白字符
        // .filter(item => item); // 过滤掉空字符串
        for (const line of lines) {
          if (line.startsWith("data: ")) {
            let data = line.slice(6); // 移除 "data: " 前缀

            if (data.trim() === "[REASON_START]") {
              data =
                "<div class='text-[#6c6c6c] font-semibold py-2 px-4 cursor-pointer transition-colors mb-4 border-l-4 border-gray-800' style='width: fit-content;'>";
              // continue;
            }

            if (data.trim() === "[REASON_DONE]") {
              data = "</div>";
              // continue;
            }

            if (data.trim() === "[ANSWER_START]") {
              continue;
            }

            if (data.trim() === "[ANSWER_DONE]") {
              continue;
            }

            if (data.trim() === "[ANSWER_END]") {
              continue;
            }

            if (data.trim() === "[ERROR]") {
              streamHasError = true;
              showAssistantError();
              continue;
            }

            if (streamHasError) {
              try {
                const parsedError = JSON.parse(data);
                if (parsedError?.message) {
                  assistantMessage = `The selected model failed: ${parsedError.message}`;
                  setMessages((prevMessages) => {
                    const newMessages = [...prevMessages];
                    const lastMessage = newMessages[newMessages.length - 1];
                    if (lastMessage?.role === "ai") {
                      lastMessage.message = assistantMessage;
                    }
                    return newMessages;
                  });
                }
              } catch {
                // Ignore malformed stream error details; the generic message is already visible.
              }
              continue;
            }

            if (data.trim() === "[RELATE_Q_DONE]") {
              setTimeout(() => {
                setIsLoading(false);
              }, 0);
              continue;
            }

            if (data.trim() === "[SOURCE_START]") {
              shouldRenderSource = true;
              continue;
            }

            if (shouldRenderSource) {
              if (data.trim() === "[SOURCE_DONE]") {
                shouldRenderSource = false;
                continue;
              } else {
                sourceData = sourceData + data;
                console.log("shouldRenderSource Data:--------", data);
              }
            }

            console.log("Data:--------", data);

            try {
              if (shouldConcatenate) {
                if (data.trim() === "[RELATE_Q_START]") {
                  assistantMessage += "";
                  shouldConcatenate = false;
                } else {
                  if (shouldRenderSource) {
                    sourceData += "";
                  } else {
                    assistantMessage += handleNewMessages(data);
                  }
                }
              } else {
                // if (!shouldConcatenate) {
                if (data === "✩") {
                  questionData += `<div class="bg-gray-50 text-[#6c6c6c] font-semibold py-2 px-4 rounded-lg cursor-pointer hover:bg-gray-100 transition-colors mb-4" style="width: fit-content;" onclick="(function(e){
      const text = e.currentTarget.textContent;
      window.handleQuestionClick && window.handleQuestionClick(text);
    })(event)">${data.replace(/✩/g, "")}`;
                } else if (data.includes("\n")) {
                  questionData += `${handleNewMessages(data)}</div>`;
                } else {
                  questionData += data;
                }
                // }
              }
              // 实时更新UI
              setMessages((prevMessages) => {
                const newMessages = [...prevMessages];
                // 更新最后一条消息，如果不存在则添加新消息
                if (
                  newMessages.length > 0 &&
                  newMessages[newMessages.length - 1].role === "ai"
                ) {
                  newMessages[newMessages.length - 1].message =
                    assistantMessage;
                  // if (!shouldConcatenate) {
                  //   if (data === "✩") {
                  //     questionData  += `<div class="question-button" style="color: red">${data}`;
                  //   }
                  //   else if (data.includes("\\n")) {
                  //     questionData  += `${handleNewMessages(data)}</div>`;
                  //   }
                  //   else {
                  //     questionData  += data;
                  //   }
                  newMessages[newMessages.length - 1].question = questionData;
                  isValidJSON(sourceData) &&
                    (newMessages[newMessages.length - 1].source = sourceData);
                  // }
                } else {
                  newMessages.push({
                    // message: handleNewMessages(assistantMessage),
                    messages: assistantMessage,
                    role: "ai",
                  });
                }
                console.log("newMessages:--------", newMessages);
                return newMessages;
              });
            } catch (e) {
              console.error("Error parsing SSE data:", e);
            }
          }
        }
      },
    }).catch((error) => {
      console.error("Error in API request:", error);
      if (error.status == 429) {
        // 未登录，跳转到登录页
        router.push(`/login?from=${encodeURIComponent(pathname)}`);
        // throw new Error("Not logged in");
      }
      showAssistantError(error);
    });
    setIsLoading(false);
    setContent("");
  };

  const onPromptsItemClick: GetProp<typeof Prompts, "onItemClick"> = (info) => {
    onSubmit(info.data.description as string, activeKey);
  };

  const renderMarkdown: BubbleProps["messageRender"] = (msg) => {
    return (
      <div>
        {/* biome-ignore lint/security/noDangerouslySetInnerHtml: used in demo */}
        <div
          dangerouslySetInnerHTML={{ __html: md.render(msg) }}
          style={{ fontSize: "16px" }}
          className="markdown-body"
        />
      </div>
    );
  };

  const onAddConversation = () => {
    setIsOpen(false);
    setNetwork(false);
    setCurrentModel(getRandomModel(isSwitchDeep));
    setConversationsItems([
      {
        key: `${conversationsItems.length}`,
        label: `${locale["newConversation"]} ${conversationsItems.length}`,
      },
      ...conversationsItems,
    ]);
    setActiveKey(`${conversationsItems.length}`);
    setIsSwitchDeep(false);
  };

  const onConversationClick: GetProp<typeof Conversations, "onActiveChange"> = (
    key
  ) => {
    setActiveKey(key);
    API.get(`/ha/v1/session/messages/history`, {
      sessionId: key,
    }).then((res) => {
      const messages = res.map((data) => {
        return {
          id: data.id,
          question: data?.related_question
            ?.map(
              (question) =>
                `<div class="bg-gray-50 text-[#6c6c6c] font-semibold py-2 px-4 rounded-lg cursor-pointer hover:bg-gray-100 transition-colors mb-4" style="width: fit-content;" onclick="(function(e){
                const text = e.currentTarget.textContent;
                window.handleQuestionClick && window.handleQuestionClick(text);
              })(event)">${question}</div>`
            )
            .join(""),
          source: data.search_source,
          status: data.role === "assistant" ? "ai" : "local",
          role: data.role === "assistant" ? "ai" : "local",
          message: data.content,
        };
      });
      console.log("messages----------", messages);
      setMessages(messages);
    });
  };

  const handleFileChange: GetProp<typeof Attachments, "onChange"> = (info) =>
    setAttachedFiles(info.fileList);

  const [network, setNetwork] = React.useState(false);
  const handleToggle = (checked) => {
    console.log(`switch to ${checked}`);
    setNetwork(checked);
  };

  // ==================== Nodes ====================
  const placeholderNode = (
    <Space direction="vertical" size={16} className={styles.placeholder}>
      <Welcome variant="borderless" title="Free ChatGPT" />
      <Prompts
        title="What can I do for you？"
        // items={placeholderPromptsItems}
        styles={{
          list: {
            width: "100%",
          },
          item: {
            flex: 1,
          },
        }}
        onItemClick={onPromptsItemClick}
      />
    </Space>
  );

  const items: GetProp<typeof Bubble.List, "items"> = messages.map(
    ({ id, message, status }) => ({
      key: id,
      loading: status === "loading",
      role: status === "local" ? "local" : "ai",
      // typing: true,
      content: message,
      messageRender: renderMarkdown,
    })
  );

  const attachmentsNode = (
    <Badge dot={attachedFiles.length > 0 && !headerOpen}>
      <Button
        type="text"
        icon={<PaperClipOutlined />}
        onClick={() => setHeaderOpen(!headerOpen)}
      />
    </Badge>
  );

  const senderHeader = (
    <Sender.Header
      title="Attachments"
      open={headerOpen}
      onOpenChange={setHeaderOpen}
      styles={{
        content: {
          padding: 0,
        },
      }}
    >
      <Attachments
        beforeUpload={() => false}
        items={attachedFiles}
        onChange={handleFileChange}
        placeholder={(type) =>
          type === "drop"
            ? { title: "Drop file here" }
            : {
                icon: <CloudUploadOutlined />,
                title: "Upload files",
                description: "Click or drag files to this area to upload",
              }
        }
      />
    </Sender.Header>
  );

  const [isOpen, setIsOpen] = React.useState(false);

  const [searchResult, setSearchResult] = React.useState([]);

  const logoNode = (
    <div className={`${styles.logo} flex items-center justify-between`}>
      {/* <img
          src="https://mdn.alipayobjects.com/huamei_iwk9zp/afts/img/A*eco6RrQhxbMAAAAAAAAAAAAADgCCAQ/original"
          draggable={false}
          alt="logo"
        /> */}
      {/* <Link href="/">Heck.ai</Link> */}
      <div>
        <FilePenLine
          className="text-[#5D5D5D] cursor-pointer"
          onClick={onAddConversation}
          style={{ width: "19px", height: "19px" }}
        />
      </div>
    </div>
  );

  const openSourceDetail = (source) => {
    if (isOpen) {
      setIsOpen(false);
      return;
    }
    console.log("source", source);
    setSearchResult(source);
    setIsOpen(true);
  };

  const isValidJSON = (str) => {
    try {
      JSON.parse(str);
      return true; // 可以解析
    } catch (e) {
      return false; // 无法解析
    }
  };

  const handleChange = (value) => {
    console.log(`selected ${value}`);
    // router.push(`/${value}?manual=true`);
    router.push(`/${value}`);
  };

  // const [scrollCount, setScrollCount] = React.useState(0);

  const pathname = usePathname();
  const searchParams = useSearchParams();

  useEffect(() => {
    const url = pathname + searchParams.toString();
    (window as any).gtag("config", "G-N98PCCD0TE", {
      page_path: url,
    });
  }, [pathname, searchParams]);

  // const containerWrapRef = React.useRef(null);
  // const [scrollAttempts, setScrollAttempts] = React.useState(0);
  // const [lastScrollTime, setLastScrollTime] = React.useState(0);
  // const [isBlocked, setIsBlocked] = React.useState(false);

  // useEffect(() => {
  //   const container = containerWrapRef.current;
  //   if (!container) return;

  //   const handleScroll = (e) => {
  //     const currentTime = new Date().getTime();

  //     if (isBlocked) {
  //       e.preventDefault();
  //       return;
  //     }

  //     // 第一次滚动
  //     if (scrollAttempts === 0) {
  //       e.preventDefault();
  //       setScrollAttempts(1);
  //       setLastScrollTime(currentTime);
  //       setIsBlocked(true);

  //       setTimeout(() => {
  //         setIsBlocked(false);
  //       }, 1500);
  //     }
  //     // 第二次滚动（3秒内）
  //     else if (scrollAttempts === 1 && currentTime - lastScrollTime < 3000) {
  //       setScrollAttempts(0);
  //       // 允许正常滚动
  //     }
  //     // 超过3秒，重置计数
  //     else if (currentTime - lastScrollTime >= 3000) {
  //       e.preventDefault();
  //       setScrollAttempts(1);
  //       setLastScrollTime(currentTime);
  //       setIsBlocked(true);

  //       setTimeout(() => {
  //         setIsBlocked(false);
  //       }, 1500);
  //     }
  //   };

  //   // 添加事件监听到特定DOM节点
  //   container.addEventListener("wheel", handleScroll, { passive: false });
  //   container.addEventListener("touchmove", handleScroll, { passive: false });

  //   return () => {
  //     // 清理事件监听
  //     container.removeEventListener("wheel", handleScroll);
  //     container.removeEventListener("touchmove", handleScroll);
  //   };
  // }, [scrollAttempts, lastScrollTime, isBlocked]);

  const [isMobileMenuOpen, setIsMobileMenuOpen] = React.useState(false);

  const toggleMobileMenu = () => {
    setIsMobileMenuOpen(!isMobileMenuOpen);
  };

  /*
  const modelData = [
    // 免费模型
    // {
    //   value: "google/gemini-2.0-flash-001",
    //   label: "Gemini 2.0 Flash",
    // },
    {
      value: "google/gemini-2.5-flash-preview",
      label: "Gemini 2.5 Flash",
    },
    {
      label: "DeepSeeK V3",
      value: "deepseek/deepseek-chat",
    },
    {
      value: "deepseek/deepseek-r1",
      label: "DeepSeek R1 Pro",
    },
    {
      value: "openai/gpt-4o-mini",
      label: "ChatGPT 4o mini",
    },
    {
      value: "openai/gpt-4.1-mini",
      label: "ChatGPT-4.1 mini",
    },
    {
      value: "x-ai/grok-3-mini-beta",
      label: "Grok 3 mini",
    },
    {
      value: "meta-llama/llama-4-scout",
      label: "Llama 4 Scout",
    },
    {
      value: "openai/gpt-5-mini",
      label: "GPT-5 Mini",
    },
    {
      value: "openai/gpt-5-nano",
      label: "GPT-5 Nano",
    },
    // 付费模型
    {
      value: "google/gemini-2.5-pro-preview",
      label: (
        <span
          style={{
            color: "#A020F0",
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
          }}
        >
          Gemini 2.5 Pro{" "}
          <svg
            t="1740643532561"
            class="icon"
            viewBox="0 0 1024 1024"
            version="1.1"
            xmlns="http://www.w3.org/2000/svg"
            p-id="2269"
            width="20"
            height="20"
          >
            <path
              d="M27.913387 507.733333l32-298.666666c2.133333-21.333333 21.333333-38.4 42.666666-38.4h108.8c36.266667 0 68.266667 14.933333 89.6 38.4 23.466667 25.6 34.133333 57.6 29.866667 93.866666l-12.8 128c-6.4 68.266667-68.266667 123.733333-138.666667 123.733334H108.980053L85.513387 772.266667c-2.133333 21.333333-21.333333 38.4-42.666667 38.4h-4.266667C15.113387 808.533333-1.95328 787.2 0.180053 763.733333l27.733334-256zM140.980053 256L117.513387 469.333333h61.866666c25.6 0 51.2-21.333333 53.333334-46.933333l12.8-128c2.133333-10.666667-2.133333-19.2-8.533334-27.733333-6.4-6.4-14.933333-10.666667-25.6-10.666667H140.980053z m522.666667 174.933333c-4.266667 44.8-32 83.2-70.4 104.533334l34.133333 226.133333c4.266667 23.466667-12.8 44.8-36.266666 49.066667h-6.4c-21.333333 0-38.4-14.933333-42.666667-36.266667L510.04672 554.666667h-53.333333l-23.466667 217.6c-2.133333 21.333333-21.333333 38.4-42.666667 38.4h-4.266666c-23.466667-2.133333-40.533333-23.466667-38.4-46.933334l27.733333-256 32-298.666666c2.133333-21.333333 21.333333-38.4 42.666667-38.4h108.8c36.266667 0 68.266667 14.933333 89.6 38.4 23.466667 25.6 32 57.6 29.866666 93.866666l-14.933333 128z m-72.533333-136.533333c2.133333-10.666667-2.133333-19.2-8.533334-27.733333-4.266667-6.4-14.933333-10.666667-25.6-10.666667h-70.4l-23.466666 213.333333h61.866666c25.6 0 51.2-21.333333 53.333334-46.933333l12.8-128zM823.64672 810.666667c-36.266667 0-68.266667-14.933333-89.6-38.4-23.466667-25.6-34.133333-57.6-29.866667-93.866667l40.533334-384C751.113387 224 810.84672 170.666667 881.24672 170.666667h21.333333c36.266667 0 68.266667 14.933333 89.6 38.4 25.6 25.6 34.133333 59.733333 32 93.866666l-40.533333 384c-6.4 68.266667-68.266667 123.733333-138.666667 123.733334h-21.333333z m-36.266667-123.733334c-2.133333 10.666667 2.133333 19.2 8.533334 27.733334 6.4 6.4 17.066667 10.666667 27.733333 10.666666h21.333333c25.6 0 51.2-21.333333 53.333334-46.933333l40.533333-384c2.133333-10.666667-2.133333-19.2-8.533333-27.733333-6.4-6.4-14.933333-10.666667-27.733334-10.666667h-21.333333c-25.6 0-51.2 21.333333-53.333333 46.933333l-40.533334 384z"
              fill="#2F3CF4"
              p-id="2270"
            ></path>
          </svg>
        </span>
      ),
    },
    {
      label: (
        <span
          style={{
            color: "#A020F0",
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
          }}
        >
          ChatGPT-4o{" "}
          <svg
            t="1740643532561"
            class="icon"
            viewBox="0 0 1024 1024"
            version="1.1"
            xmlns="http://www.w3.org/2000/svg"
            p-id="2269"
            width="20"
            height="20"
          >
            <path
              d="M27.913387 507.733333l32-298.666666c2.133333-21.333333 21.333333-38.4 42.666666-38.4h108.8c36.266667 0 68.266667 14.933333 89.6 38.4 23.466667 25.6 34.133333 57.6 29.866667 93.866666l-12.8 128c-6.4 68.266667-68.266667 123.733333-138.666667 123.733334H108.980053L85.513387 772.266667c-2.133333 21.333333-21.333333 38.4-42.666667 38.4h-4.266667C15.113387 808.533333-1.95328 787.2 0.180053 763.733333l27.733334-256zM140.980053 256L117.513387 469.333333h61.866666c25.6 0 51.2-21.333333 53.333334-46.933333l12.8-128c2.133333-10.666667-2.133333-19.2-8.533334-27.733333-6.4-6.4-14.933333-10.666667-25.6-10.666667H140.980053z m522.666667 174.933333c-4.266667 44.8-32 83.2-70.4 104.533334l34.133333 226.133333c4.266667 23.466667-12.8 44.8-36.266666 49.066667h-6.4c-21.333333 0-38.4-14.933333-42.666667-36.266667L510.04672 554.666667h-53.333333l-23.466667 217.6c-2.133333 21.333333-21.333333 38.4-42.666667 38.4h-4.266666c-23.466667-2.133333-40.533333-23.466667-38.4-46.933334l27.733333-256 32-298.666666c2.133333-21.333333 21.333333-38.4 42.666667-38.4h108.8c36.266667 0 68.266667 14.933333 89.6 38.4 23.466667 25.6 32 57.6 29.866666 93.866666l-14.933333 128z m-72.533333-136.533333c2.133333-10.666667-2.133333-19.2-8.533334-27.733333-4.266667-6.4-14.933333-10.666667-25.6-10.666667h-70.4l-23.466666 213.333333h61.866666c25.6 0 51.2-21.333333 53.333334-46.933333l12.8-128zM823.64672 810.666667c-36.266667 0-68.266667-14.933333-89.6-38.4-23.466667-25.6-34.133333-57.6-29.866667-93.866667l40.533334-384C751.113387 224 810.84672 170.666667 881.24672 170.666667h21.333333c36.266667 0 68.266667 14.933333 89.6 38.4 25.6 25.6 34.133333 59.733333 32 93.866666l-40.533333 384c-6.4 68.266667-68.266667 123.733333-138.666667 123.733334h-21.333333z m-36.266667-123.733334c-2.133333 10.666667 2.133333 19.2 8.533334 27.733334 6.4 6.4 17.066667 10.666667 27.733333 10.666666h21.333333c25.6 0 51.2-21.333333 53.333334-46.933333l40.533333-384c2.133333-10.666667-2.133333-19.2-8.533333-27.733333-6.4-6.4-14.933333-10.666667-27.733334-10.666667h-21.333333c-25.6 0-51.2 21.333333-53.333333 46.933333l-40.533334 384z"
              fill="#2F3CF4"
              p-id="2270"
            ></path>
          </svg>
        </span>
      ),
      value: "openai/chatgpt-4o-latest",
    },
    {
      label: (
        <span
          style={{
            color: "#A020F0",
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
          }}
        >
          OpenAI: o3{" "}
          <svg
            t="1740643532561"
            class="icon"
            viewBox="0 0 1024 1024"
            version="1.1"
            xmlns="http://www.w3.org/2000/svg"
            p-id="2269"
            width="20"
            height="20"
          >
            <path
              d="M27.913387 507.733333l32-298.666666c2.133333-21.333333 21.333333-38.4 42.666666-38.4h108.8c36.266667 0 68.266667 14.933333 89.6 38.4 23.466667 25.6 34.133333 57.6 29.866667 93.866666l-12.8 128c-6.4 68.266667-68.266667 123.733333-138.666667 123.733334H108.980053L85.513387 772.266667c-2.133333 21.333333-21.333333 38.4-42.666667 38.4h-4.266667C15.113387 808.533333-1.95328 787.2 0.180053 763.733333l27.733334-256zM140.980053 256L117.513387 469.333333h61.866666c25.6 0 51.2-21.333333 53.333334-46.933333l12.8-128c2.133333-10.666667-2.133333-19.2-8.533334-27.733333-6.4-6.4-14.933333-10.666667-25.6-10.666667H140.980053z m522.666667 174.933333c-4.266667 44.8-32 83.2-70.4 104.533334l34.133333 226.133333c4.266667 23.466667-12.8 44.8-36.266666 49.066667h-6.4c-21.333333 0-38.4-14.933333-42.666667-36.266667L510.04672 554.666667h-53.333333l-23.466667 217.6c-2.133333 21.333333-21.333333 38.4-42.666667 38.4h-4.266666c-23.466667-2.133333-40.533333-23.466667-38.4-46.933334l27.733333-256 32-298.666666c2.133333-21.333333 21.333333-38.4 42.666667-38.4h108.8c36.266667 0 68.266667 14.933333 89.6 38.4 23.466667 25.6 32 57.6 29.866666 93.866666l-14.933333 128z m-72.533333-136.533333c2.133333-10.666667-2.133333-19.2-8.533334-27.733333-4.266667-6.4-14.933333-10.666667-25.6-10.666667h-70.4l-23.466666 213.333333h61.866666c25.6 0 51.2-21.333333 53.333334-46.933333l12.8-128zM823.64672 810.666667c-36.266667 0-68.266667-14.933333-89.6-38.4-23.466667-25.6-34.133333-57.6-29.866667-93.866667l40.533334-384C751.113387 224 810.84672 170.666667 881.24672 170.666667h21.333333c36.266667 0 68.266667 14.933333 89.6 38.4 25.6 25.6 34.133333 59.733333 32 93.866666l-40.533333 384c-6.4 68.266667-68.266667 123.733333-138.666667 123.733334h-21.333333z m-36.266667-123.733334c-2.133333 10.666667 2.133333 19.2 8.533334 27.733334 6.4 6.4 17.066667 10.666667 27.733333 10.666666h21.333333c25.6 0 51.2-21.333333 53.333334-46.933333l40.533333-384c2.133333-10.666667-2.133333-19.2-8.533333-27.733333-6.4-6.4-14.933333-10.666667-27.733334-10.666667h-21.333333c-25.6 0-51.2 21.333333-53.333333 46.933333l-40.533334 384z"
              fill="#2F3CF4"
              p-id="2270"
            ></path>
          </svg>
        </span>
      ),
      value: "openai/o3",
    },
    {
      label: (
        <span
          style={{
            color: "#A020F0",
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
          }}
        >
          OpenAI: o4 mini{" "}
          <svg
            t="1740643532561"
            class="icon"
            viewBox="0 0 1024 1024"
            version="1.1"
            xmlns="http://www.w3.org/2000/svg"
            p-id="2269"
            width="20"
            height="20"
          >
            <path
              d="M27.913387 507.733333l32-298.666666c2.133333-21.333333 21.333333-38.4 42.666666-38.4h108.8c36.266667 0 68.266667 14.933333 89.6 38.4 23.466667 25.6 34.133333 57.6 29.866667 93.866666l-12.8 128c-6.4 68.266667-68.266667 123.733333-138.666667 123.733334H108.980053L85.513387 772.266667c-2.133333 21.333333-21.333333 38.4-42.666667 38.4h-4.266667C15.113387 808.533333-1.95328 787.2 0.180053 763.733333l27.733334-256zM140.980053 256L117.513387 469.333333h61.866666c25.6 0 51.2-21.333333 53.333334-46.933333l12.8-128c2.133333-10.666667-2.133333-19.2-8.533334-27.733333-6.4-6.4-14.933333-10.666667-25.6-10.666667H140.980053z m522.666667 174.933333c-4.266667 44.8-32 83.2-70.4 104.533334l34.133333 226.133333c4.266667 23.466667-12.8 44.8-36.266666 49.066667h-6.4c-21.333333 0-38.4-14.933333-42.666667-36.266667L510.04672 554.666667h-53.333333l-23.466667 217.6c-2.133333 21.333333-21.333333 38.4-42.666667 38.4h-4.266666c-23.466667-2.133333-40.533333-23.466667-38.4-46.933334l27.733333-256 32-298.666666c2.133333-21.333333 21.333333-38.4 42.666667-38.4h108.8c36.266667 0 68.266667 14.933333 89.6 38.4 23.466667 25.6 32 57.6 29.866666 93.866666l-14.933333 128z m-72.533333-136.533333c2.133333-10.666667-2.133333-19.2-8.533334-27.733333-4.266667-6.4-14.933333-10.666667-25.6-10.666667h-70.4l-23.466666 213.333333h61.866666c25.6 0 51.2-21.333333 53.333334-46.933333l12.8-128zM823.64672 810.666667c-36.266667 0-68.266667-14.933333-89.6-38.4-23.466667-25.6-34.133333-57.6-29.866667-93.866667l40.533334-384C751.113387 224 810.84672 170.666667 881.24672 170.666667h21.333333c36.266667 0 68.266667 14.933333 89.6 38.4 25.6 25.6 34.133333 59.733333 32 93.866666l-40.533333 384c-6.4 68.266667-68.266667 123.733333-138.666667 123.733334h-21.333333z m-36.266667-123.733334c-2.133333 10.666667 2.133333 19.2 8.533334 27.733334 6.4 6.4 17.066667 10.666667 27.733333 10.666666h21.333333c25.6 0 51.2-21.333333 53.333334-46.933333l40.533333-384c2.133333-10.666667-2.133333-19.2-8.533333-27.733333-6.4-6.4-14.933333-10.666667-27.733334-10.666667h-21.333333c-25.6 0-51.2 21.333333-53.333333 46.933333l-40.533334 384z"
              fill="#2F3CF4"
              p-id="2270"
            ></path>
          </svg>
        </span>
      ),
      value: "openai/o4-mini",
    },
    {
      label: (
        <span
          style={{
            color: "#A020F0",
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
          }}
        >
          ChatGPT-4.1{" "}
          <svg
            t="1740643532561"
            class="icon"
            viewBox="0 0 1024 1024"
            version="1.1"
            xmlns="http://www.w3.org/2000/svg"
            p-id="2269"
            width="20"
            height="20"
          >
            <path
              d="M27.913387 507.733333l32-298.666666c2.133333-21.333333 21.333333-38.4 42.666666-38.4h108.8c36.266667 0 68.266667 14.933333 89.6 38.4 23.466667 25.6 34.133333 57.6 29.866667 93.866666l-12.8 128c-6.4 68.266667-68.266667 123.733333-138.666667 123.733334H108.980053L85.513387 772.266667c-2.133333 21.333333-21.333333 38.4-42.666667 38.4h-4.266667C15.113387 808.533333-1.95328 787.2 0.180053 763.733333l27.733334-256zM140.980053 256L117.513387 469.333333h61.866666c25.6 0 51.2-21.333333 53.333334-46.933333l12.8-128c2.133333-10.666667-2.133333-19.2-8.533334-27.733333-6.4-6.4-14.933333-10.666667-25.6-10.666667H140.980053z m522.666667 174.933333c-4.266667 44.8-32 83.2-70.4 104.533334l34.133333 226.133333c4.266667 23.466667-12.8 44.8-36.266666 49.066667h-6.4c-21.333333 0-38.4-14.933333-42.666667-36.266667L510.04672 554.666667h-53.333333l-23.466667 217.6c-2.133333 21.333333-21.333333 38.4-42.666667 38.4h-4.266666c-23.466667-2.133333-40.533333-23.466667-38.4-46.933334l27.733333-256 32-298.666666c2.133333-21.333333 21.333333-38.4 42.666667-38.4h108.8c36.266667 0 68.266667 14.933333 89.6 38.4 23.466667 25.6 32 57.6 29.866666 93.866666l-14.933333 128z m-72.533333-136.533333c2.133333-10.666667-2.133333-19.2-8.533334-27.733333-4.266667-6.4-14.933333-10.666667-25.6-10.666667h-70.4l-23.466666 213.333333h61.866666c25.6 0 51.2-21.333333 53.333334-46.933333l12.8-128zM823.64672 810.666667c-36.266667 0-68.266667-14.933333-89.6-38.4-23.466667-25.6-34.133333-57.6-29.866667-93.866667l40.533334-384C751.113387 224 810.84672 170.666667 881.24672 170.666667h21.333333c36.266667 0 68.266667 14.933333 89.6 38.4 25.6 25.6 34.133333 59.733333 32 93.866666l-40.533333 384c-6.4 68.266667-68.266667 123.733333-138.666667 123.733334h-21.333333z m-36.266667-123.733334c-2.133333 10.666667 2.133333 19.2 8.533334 27.733334 6.4 6.4 17.066667 10.666667 27.733333 10.666666h21.333333c25.6 0 51.2-21.333333 53.333334-46.933333l40.533333-384c2.133333-10.666667-2.133333-19.2-8.533333-27.733333-6.4-6.4-14.933333-10.666667-27.733334-10.666667h-21.333333c-25.6 0-51.2 21.333333-53.333333 46.933333l-40.533334 384z"
              fill="#2F3CF4"
              p-id="2270"
            ></path>
          </svg>
        </span>
      ),
      value: "openai/gpt-4.1",
    },
    {
      label: (
        <span
          style={{
            color: "#A020F0",
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
          }}
        >
          Claude Sonnet 3.7{" "}
          <svg
            t="1740643532561"
            class="icon"
            viewBox="0 0 1024 1024"
            version="1.1"
            xmlns="http://www.w3.org/2000/svg"
            p-id="2269"
            width="20"
            height="20"
          >
            <path
              d="M27.913387 507.733333l32-298.666666c2.133333-21.333333 21.333333-38.4 42.666666-38.4h108.8c36.266667 0 68.266667 14.933333 89.6 38.4 23.466667 25.6 34.133333 57.6 29.866667 93.866666l-12.8 128c-6.4 68.266667-68.266667 123.733333-138.666667 123.733334H108.980053L85.513387 772.266667c-2.133333 21.333333-21.333333 38.4-42.666667 38.4h-4.266667C15.113387 808.533333-1.95328 787.2 0.180053 763.733333l27.733334-256zM140.980053 256L117.513387 469.333333h61.866666c25.6 0 51.2-21.333333 53.333334-46.933333l12.8-128c2.133333-10.666667-2.133333-19.2-8.533334-27.733333-6.4-6.4-14.933333-10.666667-25.6-10.666667H140.980053z m522.666667 174.933333c-4.266667 44.8-32 83.2-70.4 104.533334l34.133333 226.133333c4.266667 23.466667-12.8 44.8-36.266666 49.066667h-6.4c-21.333333 0-38.4-14.933333-42.666667-36.266667L510.04672 554.666667h-53.333333l-23.466667 217.6c-2.133333 21.333333-21.333333 38.4-42.666667 38.4h-4.266666c-23.466667-2.133333-40.533333-23.466667-38.4-46.933334l27.733333-256 32-298.666666c2.133333-21.333333 21.333333-38.4 42.666667-38.4h108.8c36.266667 0 68.266667 14.933333 89.6 38.4 23.466667 25.6 32 57.6 29.866666 93.866666l-14.933333 128z m-72.533333-136.533333c2.133333-10.666667-2.133333-19.2-8.533334-27.733333-4.266667-6.4-14.933333-10.666667-25.6-10.666667h-70.4l-23.466666 213.333333h61.866666c25.6 0 51.2-21.333333 53.333334-46.933333l12.8-128zM823.64672 810.666667c-36.266667 0-68.266667-14.933333-89.6-38.4-23.466667-25.6-34.133333-57.6-29.866667-93.866667l40.533334-384C751.113387 224 810.84672 170.666667 881.24672 170.666667h21.333333c36.266667 0 68.266667 14.933333 89.6 38.4 25.6 25.6 34.133333 59.733333 32 93.866666l-40.533333 384c-6.4 68.266667-68.266667 123.733333-138.666667 123.733334h-21.333333z m-36.266667-123.733334c-2.133333 10.666667 2.133333 19.2 8.533334 27.733334 6.4 6.4 17.066667 10.666667 27.733333 10.666666h21.333333c25.6 0 51.2-21.333333 53.333334-46.933333l40.533333-384c2.133333-10.666667-2.133333-19.2-8.533333-27.733333-6.4-6.4-14.933333-10.666667-27.733334-10.666667h-21.333333c-25.6 0 51.2 21.333333-53.333333 46.933333l-40.533334 384z"
              fill="#2F3CF4"
              p-id="2270"
            ></path>
          </svg>
        </span>
      ),
      value: "anthropic/claude-3.7-sonnet",
    },
    {
      label: (
        <span
          style={{
            color: "#A020F0",
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
          }}
        >
          Claude Sonnet 3.7 (thinking){" "}
          <svg
            t="1740643532561"
            class="icon"
            viewBox="0 0 1024 1024"
            version="1.1"
            xmlns="http://www.w3.org/2000/svg"
            p-id="2269"
            width="20"
            height="20"
          >
            <path
              d="M27.913387 507.733333l32-298.666666c2.133333-21.333333 21.333333-38.4 42.666666-38.4h108.8c36.266667 0 68.266667 14.933333 89.6 38.4 23.466667 25.6 34.133333 57.6 29.866667 93.866666l-12.8 128c-6.4 68.266667-68.266667 123.733333-138.666667 123.733334H108.980053L85.513387 772.266667c-2.133333 21.333333-21.333333 38.4-42.666667 38.4h-4.266667C15.113387 808.533333-1.95328 787.2 0.180053 763.733333l27.733334-256zM140.980053 256L117.513387 469.333333h61.866666c25.6 0 51.2-21.333333 53.333334-46.933333l12.8-128c2.133333-10.666667-2.133333-19.2-8.533334-27.733333-6.4-6.4-14.933333-10.666667-25.6-10.666667H140.980053z m522.666667 174.933333c-4.266667 44.8-32 83.2-70.4 104.533334l34.133333 226.133333c4.266667 23.466667-12.8 44.8-36.266666 49.066667h-6.4c-21.333333 0-38.4-14.933333-42.666667-36.266667L510.04672 554.666667h-53.333333l-23.466667 217.6c-2.133333 21.333333-21.333333 38.4-42.666667 38.4h-4.266666c-23.466667-2.133333-40.533333-23.466667-38.4-46.933334l27.733333-256 32-298.666666c2.133333-21.333333 21.333333-38.4 42.666667-38.4h108.8c36.266667 0 68.266667 14.933333 89.6 38.4 23.466667 25.6 32 57.6 29.866666 93.866666l-14.933333 128z m-72.533333-136.533333c2.133333-10.666667-2.133333-19.2-8.533334-27.733333-4.266667-6.4-14.933333-10.666667-25.6-10.666667h-70.4l-23.466666 213.333333h61.866666c25.6 0 51.2-21.333333 53.333334-46.933333l12.8-128zM823.64672 810.666667c-36.266667 0-68.266667-14.933333-89.6-38.4-23.466667-25.6-34.133333-57.6-29.866667-93.866667l40.533334-384C751.113387 224 810.84672 170.666667 881.24672 170.666667h21.333333c36.266667 0 68.266667 14.933333 89.6 38.4 25.6 25.6 34.133333 59.733333 32 93.866666l-40.533333 384c-6.4 68.266667-68.266667 123.733333-138.666667 123.733334h-21.333333z m-36.266667-123.733334c-2.133333 10.666667 2.133333 19.2 8.533334 27.733334 6.4 6.4 17.066667 10.666667 27.733333 10.66666h21.333333c25.6 0 51.2-21.333333 53.333334-46.933333l40.533333-384c2.133333-10.666667-2.133333-19.2-8.533333-27.733333-6.4-6.4-14.933333-10.666667-27.733334-10.666667h-21.333333c-25.6 0-51.2 21.333333-53.333333 46.933333l-40.533334 384z"
              fill="#2F3CF4"
              p-id="2270"
            ></path>
          </svg>
        </span>
      ),
      value: "anthropic/claude-3.7-sonnet:thinking",
    },
    {
      label: (
        <span
          style={{
            color: "#A020F0",
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
          }}
        >
          Grok 4{" "}
          <svg
            t="1740643532561"
            class="icon"
            viewBox="0 0 1024 1024"
            version="1.1"
            xmlns="http://www.w3.org/2000/svg"
            p-id="2269"
            width="20"
            height="20"
          >
            <path
              d="M27.913387 507.733333l32-298.666666c2.133333-21.333333 21.333333-38.4 42.666666-38.4h108.8c36.266667 0 68.266667 14.933333 89.6 38.4 23.466667 25.6 34.133333 57.6 29.866667 93.866666l-12.8 128c-6.4 68.266667-68.266667 123.733333-138.666667 123.733334H108.980053L85.513387 772.266667c-2.133333 21.333333-21.333333 38.4-42.666667 38.4h-4.266667C15.113387 808.533333-1.95328 787.2 0.180053 763.733333l27.733334-256zM140.980053 256L117.513387 469.333333h61.866666c25.6 0 51.2-21.333333 53.333334-46.933333l12.8-128c2.133333-10.666667-2.133333-19.2-8.533334-27.733333-6.4-6.4-14.933333-10.666667-25.6-10.666667H140.980053z m522.666667 174.933333c-4.266667 44.8-32 83.2-70.4 104.533334l34.133333 226.133333c4.266667 23.466667-12.8 44.8-36.266666 49.066667h-6.4c-21.333333 0-38.4-14.933333-42.666667-36.266667L510.04672 554.666667h-53.333333l-23.466667 217.6c-2.133333 21.333333-21.333333 38.4-42.666667 38.4h-4.266666c-23.466667-2.133333-40.533333-23.466667-38.4-46.933334l27.733333-256 32-298.666666c2.133333-21.333333 21.333333-38.4 42.666667-38.4h108.8c36.266667 0 68.266667 14.933333 89.6 38.4 23.466667 25.6 32 57.6 29.866666 93.866666l-14.933333 128z m-72.533333-136.533333c2.133333-10.666667-2.133333-19.2-8.533334-27.733333-4.266667-6.4-14.933333-10.666667-25.6-10.666667h-70.4l-23.466666 213.333333h61.866666c25.6 0 51.2-21.333333 53.333334-46.933333l12.8-128zM823.64672 810.666667c-36.266667 0-68.266667-14.933333-89.6-38.4-23.466667-25.6-34.133333-57.6-29.866667-93.866667l40.533334-384C751.113387 224 810.84672 170.666667 881.24672 170.666667h21.333333c36.266667 0 68.266667 14.933333 89.6 38.4 25.6 25.6 34.133333 59.733333 32 93.866666l-40.533333 384c-6.4 68.266667-68.266667 123.733333-138.666667 123.733334h-21.333333z m-36.266667-123.733334c-2.133333 10.666667 2.133333 19.2 8.533334 27.733334 6.4 6.4 17.066667 10.666667 27.733333 10.666666h21.333333c25.6 0 51.2-21.333333 53.333334-46.933333l40.533333-384c2.133333-10.666667-2.133333-19.2-8.533333-27.733333-6.4-6.4-14.933333-10.666667-27.733334-10.666667h-21.333333c-25.6 0-51.2 21.333333-53.333333 46.933333l-40.533334 384z"
              fill="#2F3CF4"
              p-id="2270"
            ></path>
          </svg>
        </span>
      ),
      value: "x-ai/grok-4",
    },
    {
      label: (
        <span
          style={{
            color: "#A020F0",
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
          }}
        >
          Llama 4 Maverick{" "}
          <svg
            t="1740643532561"
            class="icon"
            viewBox="0 0 1024 1024"
            version="1.1"
            xmlns="http://www.w3.org/2000/svg"
            p-id="2269"
            width="20"
            height="20"
          >
            <path
              d="M27.913387 507.733333l32-298.666666c2.133333-21.333333 21.333333-38.4 42.666666-38.4h108.8c36.266667 0 68.266667 14.933333 89.6 38.4 23.466667 25.6 34.133333 57.6 29.866667 93.866666l-12.8 128c-6.4 68.266667-68.266667 123.733333-138.666667 123.733334H108.980053L85.513387 772.266667c-2.133333 21.333333-21.333333 38.4-42.666667 38.4h-4.266667C15.113387 808.533333-1.95328 787.2 0.180053 763.733333l27.733334-256zM140.980053 256L117.513387 469.333333h61.866666c25.6 0 51.2-21.333333 53.333334-46.933333l12.8-128c2.133333-10.666667-2.133333-19.2-8.533334-27.733333-6.4-6.4-14.933333-10.666667-25.6-10.666667H140.980053z m522.666667 174.933333c-4.266667 44.8-32 83.2-70.4 104.533334l34.133333 226.133333c4.266667 23.466667-12.8 44.8-36.266666 49.066667h-6.4c-21.333333 0-38.4-14.933333-42.666667-36.266667L510.04672 554.666667h-53.333333l-23.466667 217.6c-2.133333 21.333333-21.333333 38.4-42.666667 38.4h-4.266666c-23.466667-2.133333-40.533333-23.466667-38.4-46.933334l27.733333-256 32-298.666666c2.133333-21.333333 21.333333-38.4 42.666667-38.4h108.8c36.266667 0 68.266667 14.933333 89.6 38.4 23.466667 25.6 32 57.6 29.866666 93.866666l-14.933333 128z m-72.533333-136.533333c2.133333-10.666667-2.133333-19.2-8.533334-27.733333-4.266667-6.4-14.933333-10.666667-25.6-10.666667h-70.4l-23.466666 213.333333h61.866666c25.6 0 51.2-21.333333 53.333334-46.933333l12.8-128zM823.64672 810.666667c-36.266667 0-68.266667-14.933333-89.6-38.4-23.466667-25.6-34.133333-57.6-29.866667-93.866667l40.533334-384C751.113387 224 810.84672 170.666667 881.24672 170.666667h21.333333c36.266667 0 68.266667 14.933333 89.6 38.4 25.6 25.6 34.133333 59.733333 32 93.866666l-40.533333 384c-6.4 68.266667-68.266667 123.733333-138.666667 123.733334h-21.333333z m-36.266667-123.733334c-2.133333 10.666667 2.133333 19.2 8.533334 27.733334 6.4 6.4 17.066667 10.666667 27.733333 10.666666h21.333333c25.6 0 51.2-21.333333 53.333334-46.933333l40.533333-384c2.133333-10.666667-2.133333-19.2-8.533333-27.733333-6.4-6.4-14.933333-10.666667-27.733334-10.666667h-21.333333c-25.6 0-51.2 21.333333-53.333333 46.933333l-40.533334 384z"
              fill="#2F3CF4"
              p-id="2270"
            ></path>
          </svg>
        </span>
      ),
      value: "meta-llama/llama-4-maverick",
    },
    {
      label: (
        <span
          style={{
            color: "#A020F0",
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
          }}
        >
          GPT-5 Chat{" "}
          <svg
            t="1740643532561"
            class="icon"
            viewBox="0 0 1024 1024"
            version="1.1"
            xmlns="http://www.w3.org/2000/svg"
            p-id="2269"
            width="20"
            height="20"
          >
            <path
              d="M27.913387 507.733333l32-298.666666c2.133333-21.333333 21.333333-38.4 42.666666-38.4h108.8c36.266667 0 68.266667 14.933333 89.6 38.4 23.466667 25.6 34.133333 57.6 29.866667 93.866666l-12.8 128c-6.4 68.266667-68.266667 123.733333-138.666667 123.733334H108.980053L85.513387 772.266667c-2.133333 21.333333-21.333333 38.4-42.666667 38.4h-4.266667C15.113387 808.533333-1.95328 787.2 0.180053 763.733333l27.733334-256zM140.980053 256L117.513387 469.333333h61.866666c25.6 0 51.2-21.333333 53.333334-46.933333l12.8-128c2.133333-10.666667-2.133333-19.2-8.533334-27.733333-6.4-6.4-14.933333-10.666667-25.6-10.666667H140.980053z m522.666667 174.933333c-4.266667 44.8-32 83.2-70.4 104.533334l34.133333 226.133333c4.266667 23.466667-12.8 44.8-36.266666 49.066667h-6.4c-21.333333 0-38.4-14.933333-42.666667-36.266667L510.04672 554.666667h-53.333333l-23.466667 217.6c-2.133333 21.333333-21.333333 38.4-42.666667 38.4h-4.266666c-23.466667-2.133333-40.533333-23.466667-38.4-46.933334l27.733333-256 32-298.666666c2.133333-21.333333 21.333333-38.4 42.666667-38.4h108.8c36.266667 0 68.266667 14.933333 89.6 38.4 23.466667 25.6 32 57.6 29.866666 93.866666l-14.933333 128z m-72.533333-136.533333c2.133333-10.666667-2.133333-19.2-8.533334-27.733333-4.266667-6.4-14.933333-10.666667-25.6-10.666667h-70.4l-23.466666 213.333333h61.866666c25.6 0 51.2-21.333333 53.333334-46.933333l12.8-128zM823.64672 810.666667c-36.266667 0-68.266667-14.933333-89.6-38.4-23.466667-25.6-34.133333-57.6-29.866667-93.866667l40.533334-384C751.113387 224 810.84672 170.666667 881.24672 170.666667h21.333333c36.266667 0 68.266667 14.933333 89.6 38.4 25.6 25.6 34.133333 59.733333 32 93.866666l-40.533333 384c-6.4 68.266667-68.266667 123.733333-138.666667 123.733334h-21.333333z m-36.266667-123.733334c-2.133333 10.666667 2.133333 19.2 8.533334 27.733334 6.4 6.4 17.066667 10.666667 27.733333 10.666666h21.333333c25.6 0 51.2-21.333333 53.333334-46.933333l40.533333-384c2.133333-10.666667-2.133333-19.2-8.533333-27.733333-6.4-6.4-14.933333-10.666667-27.733334-10.666667h-21.333333c-25.6 0 51.2 21.333333-53.333333 46.933333l-40.533334 384z"
              fill="#2F3CF4"
              p-id="2270"
            ></path>
          </svg>
        </span>
      ),
      value: "openai/gpt-5-chat",
    },
  ];
  */

  const getRandomModel = (switchDeep) => {
    return pickRandomModel(switchDeep);
  };

  const [isSwitchDeep, setIsSwitchDeep] = React.useState(false);
  const [currentModel, setCurrentModel] = React.useState(() => getRandomModel(false));
  const [stripePublicKey, setStripePublicKey] = React.useState("");
  const [isProUser, setIsProUser] = React.useState(false);
  const [open, setOpen] = React.useState(false);
  const [size, setSize] = React.useState<DrawerProps["size"]>();

  const handleModelChange = (value) => {
    // 检查是否为付费模型
    if (isPaidModel(value)) {
      !isProUser && setOpen(true);
    }
    setCurrentModel(value);
  };

  const handleToggleDeep = (value) => {
    value ? setCurrentModel(DEEP_MODE_MODEL_ID) : setCurrentModel(pickRandomModel(false));
    setIsSwitchDeep(value);
  }
    const [userData, setUserData] = React.useState(null);

    // 获取价格信息和用户付费状态
    useEffect(() => {
      async function getPriceInfo() {
        try {
          const res = await API.get("/stripe/price-info");
          console.log(res);
          const stripe_public_key = res.stripe_public_key;
          setStripePublicKey(stripe_public_key);
          setIsProUser(
            res.planInfo == null || res.planInfo?.id == "base" ? false : true
          );
        } catch (error) {
          console.error("获取价格信息失败:", error);
          setIsProUser(false); // 默认设置为非专业用户
          if (error.status == 401) {
            localStorage.removeItem("token");
            localStorage.removeItem("user");
            window.location.reload();
          }
        }
      }
      getPriceInfo();
    }, []);

    // 处理订阅
    const handleSubscribe = async (plan) => {
      try {
        window.localStorage && window.localStorage.removeItem("priceId");
        const response = await API.post("/stripe/checkout-session", {
          priceId: plan.priceId,
          success_url: window.location.href,
          cancel_url: window.location.href,
        });
        if (response.sessionId) {
          const stripe = await loadStripe(stripePublicKey);
          const result = await stripe.redirectToCheckout({
            sessionId: response.sessionId,
          });
          if (result?.error) {
            console.log(
              result.error.message || "Failed to start checkout process"
            );
          }
        }
      } catch (error) {
        console.error("Subscription failed:", error);
      }
    };

    React.useEffect(() => {
      const getSessionHistoryUser = async () => {
        try {
          const res = await API.get("/ha/v1/session/history/user")
          console.log("res session/history/user", res)
          if (res.length > 0) {
            const data = res.map((item) => {
              return {
                key: item.id,
                label: item.title,
              }
            })
            setConversationsItems([
              ...conversationsItems,
              ...data
            ])
          }
        } catch (error) {
          console.log("error", error.status)
          if (error.status === 401) {
            console.log('用户没有登录----');
          }
        }
      }
      const getUserData = async () => {
        try {
          const res = await API.get('/ha/v1/auth/me')
          if (res.userInfo) {
            setUserData(res.userInfo)
          }
        } catch (error) {
          console.log("error", error.status)
          if (error.status === 401) {
            console.log('用户没有登录----');
          }
        }
  
      }
      getSessionHistoryUser()
      getUserData()
    }, [])

    const [currentSession, setCurrentSession] = React.useState(null);
    let isCreate = false;

    // Drawer 控制函数
    const onClose = () => {
      setOpen(false);
    };

  return (
    <>
    {/* Facebook Meta Pixel */}
    <Script
        id="facebook-pixel" // 添加 id
        strategy="afterInteractive"
        dangerouslySetInnerHTML={{
          __html: `
            !function(f,b,e,v,n,t,s)
            {if(f.fbq)return;n=f.fbq=function(){n.callMethod?
            n.callMethod.apply(n,arguments):n.queue.push(arguments)};
            if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
            n.queue=[];t=b.createElement(e);t.async=!0;
            t.src=v;s=b.getElementsByTagName(e)[0];
            s.parentNode.insertBefore(t,s)}(window, document,'script',
            'https://connect.facebook.net/en_US/fbevents.js');
            fbq('init', '484487911397810');
            fbq('track', 'PageView');
          `,
        }}
      />
      {/* Facebook Pixel NoScript */}
      <noscript>
        <img
          height="1"
          width="1"
          style={{ display: 'none' }}
          src="https://www.facebook.com/tr?id=484487911397810&ev=PageView&noscript=1"
        />
      </noscript>
      <Script
        strategy="afterInteractive"
        src={`https://www.googletagmanager.com/gtag/js?id=G-N98PCCD0TE`}
      />
      <Script
        id="google-analytics"
        strategy="afterInteractive"
        dangerouslySetInnerHTML={{
          __html: `
            window.dataLayer = window.dataLayer || [];
            function gtag(){dataLayer.push(arguments);}
            gtag('js', new Date());
            gtag('config', 'G-N98PCCD0TE');
          `,
        }}
      />
      <Script
        strategy="afterInteractive"
        src={`https://www.googletagmanager.com/gtag/js?id=AW-11530012869`}
      />
      <Script
        id="google-analytics"
        strategy="afterInteractive"
        dangerouslySetInnerHTML={{
          __html: `
              window.dataLayer = window.dataLayer || [];
            function gtag(){dataLayer.push(arguments);}
            gtag('js', new Date());
            gtag('config', 'AW-11530012869');
          `,
        }}
      />
      {/* <AppContextProvider> */}
      {/* <GoogleLogin /> */}
      {!!!(
        typeof window !== "undefined" && window.localStorage.getItem("token")
      ) && <GoogleLogin />}
      <div
        className="relative min-h-screen bg-white"
        style={{ height: "100dvh" }}
      >
        {/* ref={containerWrapRef} */}
        {/* Mobile Header */}
        <header className="fixed top-0 left-0 right-0 bg-white z-50 border-b">
          <div className="flex items-center justify-between px-4 h-16">
            <button onClick={toggleMobileMenu} className="lg:hidden p-2">
              <Menu size={24} className="text-gray-700" />
            </button>

            <div className="flex items-center">
              {/* <span className="text-xl font-bold">Heck.ai</span> */}
              <Select
                size="large"
                onChange={handleModelChange}
                style={{ width: 200 }}
                value={currentModel}
                options={MODEL_SELECT_OPTIONS}
              />
            </div>

            {/* <Select
                style={{ width: 100 }}
                onChange={handleChange}
                value={language}
                options={Object.keys(lgData).map((key) => ({
                  label: lgData[key],
                  value: key,
                }))}
              /> */}
            <button onClick={onAddConversation} className="lg:hidden p-2">
              <FilePenLine
                className="text-[#5D5D5D] cursor-pointer"
                size={24}
              />
            </button>
          </div>
        </header>

        {/* Mobile Sidebar */}
        <div
          className={`
            fixed top-0 left-0 h-full w-80 bg-white z-50 transform transition-transform duration-300 ease-in-out
            ${isMobileMenuOpen ? "translate-x-0" : "-translate-x-full"}
            lg:translate-x-0 lg:static lg:block
            shadow-lg
          `}
        >
          <div className="h-full flex flex-col">
            {/* Logo Section */}
            <div className="h-16 flex items-center justify-between px-4 border-b">
              {/* <span className="text-xl font-bold">Heck.ai</span> */}
              <Link href="/" className="text-xl font-bold">
                Heck.ai
              </Link>
              <div className="flex items-center">
                <Select
                  style={{ width: 100 }}
                  onChange={handleChange}
                  value={language}
                  options={Object.keys(lgData).map((key) => ({
                    label: lgData[key],
                    value: key,
                  }))}
                />
                {
                userData ? (
                  <p className="ml-4">{userData.name}</p>
                ) : (
                  <Button type="primary" size="middle" className="ml-4" onClick={() => {
                    router.push(`/login?from=${encodeURIComponent(pathname)}`);
                  }}>Login</Button>
                )
                }
                <button onClick={toggleMobileMenu} className="lg:hidden p-2">
                  <X size={24} className="text-gray-700" />
                </button>
              </div>
            </div>

            {/* Conversations List */}
            <div className="flex-1 overflow-y-auto">
              <Conversations
                items={conversationsItems}
                activeKey={activeKey}
                onActiveChange={(key) => {
                  onConversationClick(key);
                  setIsMobileMenuOpen(false);
                }}
              />
            </div>

            {/* Footer Links */}
            <div className="p-4 border-t">
              <div className="flex justify-between text-sm">
                <Link
                  href="/term-of-use"
                  className="text-gray-600 hover:text-blue-600"
                >
                  Term of use
                </Link>
                <Link
                  href="/privacy-policy"
                  className="text-gray-600 hover:text-blue-600"
                >
                  Privacy Policy
                </Link>
              </div>
            </div>
          </div>
        </div>

        {/* Main Content */}
        <main
          className="lg:pl-64 flex flex-col min-h-screen"
          style={{ height: "100dvh" }}
        >
          {/* Chat Messages */}
          <div
            className={`overflow-y-auto px-4 ${
              messages.length > 0 ? "h-[calc(100vh-240px)]" : ""
            }`}
            ref={containerRef}
            style={{ willChange: "scroll-position" }}
          >
            {messages.length > 0 ? (
              messages.map((msg, index) => (
                <div
                  key={index}
                  className={
                    `max-w-3xl mx-auto mb-6 ` + (index === 0 ? "pt-20" : "")
                  }
                >
                  <Bubble
                    placement={msg.role === "local" ? "end" : "start"}
                    content={msg.message}
                    messageRender={(message) =>
                      renderMarkdown(message)
                    }
                    variant={msg.role === "ai" ? "borderless" : "filled"}
                    loading={msg.message === ""}
                    avatar={
                      msg.role === "ai"
                        ? {
                            children: (
                              <img src="https://heck.ai/favicon.ico" alt="AI" />
                            ),
                            style: {
                              background: "transparent",
                              // border: "1px solid #e5e5e5",
                            },
                          }
                        : null
                    }
                  />

                  {/* Sources */}
                  {msg.source && (isValidJSON(msg.source) ? (
                    <div
                      className="mt-2 inline-flex items-center text-blue-500 py-2 px-4 border rounded-lg cursor-pointer hover:bg-gray-50"
                      onClick={() => openSourceDetail(JSON.parse(msg.source))}
                    >
                      Sources ({JSON.parse(msg.source).length})
                    </div>
                  ) : (
                    <div
                        className="my-4 flex flex-col font-semibold text-blue-500 py-2 px-4 border border-[#e5e5e5] rounded-lg cursor-pointer"
                        style={{ width: "fit-content" }}
                        onClick={() =>
                          openSourceDetail(msg.source)
                        }
                      >
                        Sources {msg.source.length}
                      </div>
                      ))}
                  {/* Question suggestions */}
                  {msg.question && isCustomMade && (
                    <div
                      className="mt-4"
                      dangerouslySetInnerHTML={{ __html: msg.question }}
                    />
                  )}
                </div>
              ))
            ) : (
              <div className="flex flex-col items-center justify-center h-[calc(100vh-240px)] px-4 text-center">
                <h1 className="text-2xl md:text-3xl lg:text-4xl font-bold mb-4 text-gray-900">
                  Heck.ai <br />
                  {locale["freeChatgpt"]}
                </h1>
                {/* <h2 className="text-xl md:text-2xl font-bold text-gray-900">
                    {locale["freeChatgpt"]}
                  </h2> */}
                  {(!userData || (userData && !isProUser)) && (
                 <div className="mt-4 flex flex-col items-center gap-3">
                   {/* <button 
                     onClick={() => setOpen(true)}
                     className="text-[#A020F0] font-bold text-xl hover:underline"
                   >
                     Upgrade VIP
                   </button> */}
                   <button 
                     onClick={() => setOpen(true)}
                     className="flex items-center justify-center gap-2 rounded-full bg-[#F1F1FB] py-3 px-6 text-lg font-medium text-[#5D5BD0] hover:bg-[#E4E4F6] dark:bg-[#373669] dark:text-[#DCDBF6] dark:hover:bg-[#414071] whitespace-nowrap min-w-[150px] w-[80%] max-w-[280px]"
                   >
                     <svg width="24" height="24" viewBox="0 0 20 20" fill="currentColor" xmlns="http://www.w3.org/2000/svg" className="icon-sm">
                       <path d="M17.665 10C17.665 10.6877 17.1785 11.2454 16.5488 11.3945L16.4219 11.4189C14.7098 11.6665 13.6129 12.1305 12.877 12.8623C12.1414 13.5938 11.6742 14.6843 11.4238 16.3887C11.3197 17.0973 10.7182 17.665 9.96484 17.665C9.27085 17.665 8.68836 17.1772 8.53613 16.5215C8.12392 14.7459 7.6623 13.619 6.95703 12.8652C6.31314 12.1772 5.39414 11.7268 3.88672 11.4688L3.57715 11.4199C2.88869 11.319 2.33496 10.734 2.33496 10C2.33496 9.26603 2.88869 8.681 3.57715 8.58008L3.88672 8.53125C5.39414 8.27321 6.31314 7.82277 6.95703 7.13477C7.6623 6.38104 8.12392 5.25413 8.53613 3.47852L8.56934 3.35742C8.76133 2.76356 9.31424 2.33496 9.96484 2.33496C10.7182 2.33497 11.3197 2.9027 11.4238 3.61133L11.5283 4.22266C11.7954 5.58295 12.2334 6.49773 12.877 7.1377C13.6129 7.86952 14.7098 8.33351 16.4219 8.58105C17.1119 8.68101 17.665 9.26667 17.665 10Z"></path>
                     </svg>
                     Get Ultra
                   </button>
                 </div>
               )}
              </div>
            )}
          </div>

          {/* Message Input */}
          <div className="sticky bottom-0 bg-white border-t p-4">
            <div className="max-w-3xl mx-auto">
              <MessageSenderMobile
                value={content}
                onChange={setContent}
                loading={isLoading}
                changeNetwork={handleToggle}
                isSwitch={network}
                networkText={locale["search"]}
                typeMessageText={locale["typeMessage"]}
                isCustomMade={isCustomMade}
                changeDeep={handleToggleDeep}
                isSwitchDeep={isSwitchDeep}
                onSubmit={(text) => {
                  if (messages.length === 0) {
                    if (isCreate) return;
                    isCreate = true;
                    API.post("/ha/v1/session/create", { title: text }).then(
                      (res) => {
                        setCurrentSession(res.id)
                        setConversationsItems((prev) => {
                          const updatedItems = [...prev];
                          if (updatedItems.length > 0) {
                            updatedItems[0] = {
                              ...updatedItems[0],
                              key: res.id, // 替换为你的新 key
                              label: res.title, // 替换为你的新 label
                            };
                          }
                          return updatedItems;
                        });
                        // setTimeout(()=> {
                        isCreate = true;
                        onSubmit(text, res.id);
                      }
                    ).catch((error) => {
                      if (error.status === 401) {
                        router.push(`/login?from=${encodeURIComponent(pathname)}`);
                      }
                    });
                  } else {
                    onSubmit(text, currentSession);
                  }
                }}
              />
            </div>
          </div>
        </main>

        {/* Source Panel (Slide from right on mobile) */}
        <div
          className={`
            fixed top-0 right-0 h-full bg-white z-50 transform transition-transform duration-300 ease-in-out
            ${isOpen ? "translate-x-0" : "translate-x-full"}
            w-full md:w-96
          `}
        >
          <div className="h-full flex flex-col">
            <div className="h-16 flex items-center justify-between px-4 border-b">
              <h2 className="text-xl font-semibold">Source</h2>
              <button onClick={() => setIsOpen(false)} className="p-2">
                <X size={24} className="text-gray-700" />
              </button>
            </div>

            <div className="flex-1 overflow-y-auto p-4 space-y-4">
              {searchResult.map((result) => (
                <a
                  key={result.url}
                  href={result.url}
                  target="_blank"
                  className="block p-4 border rounded-lg hover:bg-gray-50"
                >
                  <h3 className="font-medium text-lg text-gray-900">
                    {result.title}
                  </h3>
                  <p className="mt-1 text-gray-600">{result.content}</p>
                </a>
              ))}
            </div>
          </div>
        </div>

        {/* 付费弹窗 */}
        <Drawer
          title={`Heck.ai`}
          placement="right"
          width={"100%"}
          onClose={onClose}
          open={open}
          extra={
            <Space>
              <Button onClick={onClose}>Cancel</Button>
              <Button type="primary" onClick={onClose}>
                OK
              </Button>
            </Space>
          }
        >
          <PricingPlans />
        </Drawer>
      </div>
      {/* </AppContextProvider> */}
    </>
  );
};

export default IndependentMobile;
